<template>
    <div class="point-block">
        <div class="wrapper">
            <div class="left">
                <div class="img">
                    <img src="static/img/main/point4/img.png" alt="">
                </div>
                <div class="img-over point-img4">
                    <img src="static/img/main/point4/img-over.png" alt="">
                </div>
                <div class="square"></div>
            </div>
            <div class="right">
                <span class="quotes quotes-right">
                    <span class="text">
                        Солнечная Сицилия&nbsp;&mdash; очень красивый и&nbsp;разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с&nbsp;природой
                    </span>
                </span>
                <div class="info">
                    <span class="point">
                        <span class="text">
                            Сицилия, Италия
                        </span>
                    </span>
                    <h3 class="head">
                        Солнечная Сицилия
                    </h3>
                    <span class="desc">
                        Сицилийские цитрусовые занимают важное место на рынке европейских...
                    </span>
                    <a href="#" class="btn" @click.prevent="openPopup">
                        Смотреть
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 87.2 65.2" style="enable-background:new 0 0 87.2 65.2;" xml:space="preserve">
                                    <path class="st0" d="M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2
                                        l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2
                                        c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"/>
                                </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Helpers from '@/tools/Helpers';
    export default {
        name: 'point4',
        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },
            openPopup() {
                this.$store.commit('SET_POPUP', 'popup4');
                this.gaEvents('places','click','show 4');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// point4.vue?7c83d371